import React from "react";
import { Box, Stack, Typography, Divider } from "digiwash-components";
import CustomIcon from "../CustomIcon";

function DigiwashServicesSection() {
  return (
    <Stack distribution="center">
      <Stack
        distribution="space-between"
        style={{ width: "100%", maxWidth: 420 }}
      >
        <Box style={{ alignItems: "center" }}>
          <CustomIcon icon="iron" width={32} height={32} />
          <Divider size="m" />
          <Typography numberOfLines={1}>اتو</Typography>
        </Box>
        <Box style={{ alignItems: "center" }}>
          <CustomIcon icon="wash" width={32} height={32} />
          <Divider size="m" />
          <Typography numberOfLines={1}>شستشو</Typography>
        </Box>

        <Box style={{ alignItems: "center" }}>
          <CustomIcon icon="stainRemover" width={32} height={32} />
          <Divider size="m" />
          <Typography numberOfLines={1}>لکه بری</Typography>
        </Box>
        <Box style={{ alignItems: "center" }}>
          <CustomIcon icon="tailoring" width={32} height={32} />
          <Divider size="m" />
          <Typography numberOfLines={1}>خیاطی و تعمیرات</Typography>
        </Box>
      </Stack>
    </Stack>
  );
}

export default DigiwashServicesSection;
